// API Configuration
import { Capacitor } from '@capacitor/core';

const getApiUrl = () => {
  // Use VITE_API_URL from environment variables if available
  let envApiUrl = import.meta.env.VITE_API_URL;

  // If running on native platform (iOS/Android), replace localhost with host machine IP
  if (envApiUrl && Capacitor.isNativePlatform()) {
    const hostIP = import.meta.env.VITE_HOST_IP;

    if (hostIP && envApiUrl.includes('localhost')) {
      envApiUrl = envApiUrl.replace('localhost', hostIP);
      console.log('🔧 Native platform detected - using host IP:', hostIP);
    }
  }

  if (envApiUrl) {
    // Ensure it includes /api suffix if not already present
    return envApiUrl.endsWith('/api') ? envApiUrl : `${envApiUrl}/api`;
  }

  // Check if we're in production (Static Web App)
  if (import.meta.env.PROD) {
    // In production, use the backend URL
    return 'https://amplify-backend-dev.azurewebsites.net/api';
  }

  // Fallback to localhost
  return 'http://localhost:8000/api';
};

export const API_BASE_URL = getApiUrl();

// Debug: Log the API URL being used
console.log('🔧 API_BASE_URL:', API_BASE_URL);
console.log('🔧 VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('🔧 Platform:', Capacitor.getPlatform());
